<template>
  <modal :visible="visible" @close="close">
    <div>
      <article class="media">
        <div class="media-content">
          <div class="heading">
            <h4>
              {{title}}
            </h4>
          </div>
          <audio-recorder
            :attempts="1"
            :time="2"
            @close="close"
            @confirm="confirmAction"
          />
        </div>
      </article>
    </div>
  </modal>
</template>


<script>
  import { Modal } from 'vue-bulma-modal'
  import audioRecorder from '../audiorecording/audioRecorder'

  export default {
    components: {
      Modal,
      audioRecorder
    },

    props: {
      visible: Boolean,
      title: String,
      audioUrl: ''
    },

    methods: {
      close () {
        this.$emit('close')
      },
      confirmAction (value) {
        this.$emit('confirm', value)
      }
    }
  }

</script>
<style>
  .modal {
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
  }
  .modal .modal-body {
    text-align: center;
    padding-top: 20px;
    width: auto;
    height: auto;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// ModalAudio.vue?24d8cd29